var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"start"}},[_c('div',{ref:"shop",attrs:{"id":"shop"},on:{"click":_vm.goToShop}},[_c('div',{attrs:{"id":"enter"}}),_c('div',{ref:"shopHand",attrs:{"id":"shop-hand"}})]),_c('div',{attrs:{"id":"hover_bg"}})])}
var staticRenderFns = []

export { render, staticRenderFns }